// Must stay in step with Labs::NounAudio.filename - the filename is derived
// from the written form on both sides rather than carried in the page, so the
// two transforms have to agree exactly.
//
// NFC matters: the same word decomposed is a different byte string on S3, and
// the failure is a silent 404.
export function audioFilename(written) {
  return `${written.normalize("NFC").trim().toLowerCase().replace(/[\s']/g, "-")}.mp3`;
}

export function audioUrl(baseUrl, written) {
  if (!baseUrl) return null;

  return `${baseUrl}/${encodeURIComponent(audioFilename(written))}`;
}
